import { Table } from "antd";
import Moment from "moment";
import { useNavigate } from "react-router";
import Actions from "../../components/Common/Actions/index";
import SelectComponent from "../../components/Common/Select";
import scroll from "../../assets/webp/scroll.webp";

export const PartneredDoctors = [
  { text: "HealthSynergy", link: "/doctor-registration" },
  { text: " HealthSy Partnered Doctors Network Programme", link: "" },
];

export const PartneredPharmacy = [
  { text: "HealthSynergy", link: "/doctor-registration" },
  { text: "HealthSy Partnered Pharmacy Network Programme", link: "" },
];

export const HomeHealthcareServiceProvider = [
  { text: "HealthSynergy", link: "/doctor-registration" },
  {
    text: "HealthSy Partnered Home Healthcare Service Provider Network Programme",
    link: "",
  },
];

export const InstaDoc = [
  { text: "HealthSynergy", link: "/doctor-registration" },
  { text: "InstaDoc", link: "" },
];

export const Others = [
  { text: "HealthSynergy", link: "/doctor-registration" },
  { text: "Others", link: "" },
];

export const BookDemo = [
  { text: "HealthSynergy", link: "/doctor-registration" },
  { text: "Book a Demo", link: "" },
];

export const HealthSynergynavBarData = [
  {
    name: "Doctors",
    navigatePath: "/doctor-registration",
  },
  {
    name: "Retail Pharmacy",
    navigatePath: "/pharmacy-registration",
  },
  {
    name: "Home Healthcare Service Providers",
    navigatePath: "/healthcare-registration",
  },
  {
    name: "InstaDoc",
    navigatePath: "/insta-doc",
    className: "career-tab-jobpost career-gender",
  },
  {
    name: "Others",
    className: "mx-5",
    navigatePath: "/other-registration",
  },
  {
    name: "Book a Demo",
    className: "mx-5",
    navigatePath: "/doctor-demo",
  },
];

export const DoctorRegistrationfilterOptions = [
  "Fee",
  "Experience",
  "Gender",
  "Language",
  "City / Town",
  "Primary Specialisation",
  "Lead Status",
  "BD",
];

export const DoctorRegistrationcolumnOrder = [
  "S.No",
  "Time of Registration",
  "Date of Registration",
  "Name of the Doctor",
  "Contact Number",
  "Email ID",
  "Degree",
  "PG Degree",
  "Other Certified Education",
  "Gender",
  "Primary Specialisation",
  "MCI / SMC Number",
  "Year of Registration with Medical Council",
  "Council Type",
  "State Medical Council",
  "Awards & Recognition",
  "Organisation",
  "Fellowship",
  "Mode of Consultation",
  "Memberships",
  "About Yourself",
  "Online Fee",
  "In-Clinic Fee",
  "Primary Language",
  "Other Language Known",
  "State",
  "City",
  "Location",
  "Pincode",
  "Clinic Name",
  "Clinic Address",
  // "Clinic Contact Number",
  "PoC Name",
  "PoC Number",
  "Clinic Name - 2",
  "Clinic Address - 2",
  // "Clinic Contact Number - 2",
  "PoC Name",
  "PoC Number",
  "Clinic Name - 3",
  "Clinic Address - 3",
  // "Clinic Contact Number - 3",
  "PoC Name",
  "PoC Number",
  "Are you currently using telemedicine platform",
  "Establishment Details",
  "BD Name",
  "App Download Android Click",
  "App Download iOS Click",
  "Brochure Icon Click Status (1.0)",
  "Assigned To",
  "Lead Status",
  // "Actions",
];

export const PartneredDoctorscolumnOrder = [
  "S.No",
  "Time of Registration",
  "Date of Registration",
  "First Name",
  "Last Name",
  "Pharmacy Name",
  "Mobile Number",
  "Email ID",
  "Pharmacy Business Type",
  "Company Name",
  "Pharmacy GST Number",
  "Drug License Number",
  "FSSAI Number",
  "Pharmacist Name",
  "Your pharmacist's license number",
  "State",
  "City",
  "Pharmacy Location",
  "Address",
  "Pincode",
  "Medicines Listing Fee (%)",
  "OTC Listing Fee (%)",
  "What is the approximate size of your pharmacy store?",
  "What is the value of inventory you have in your pharmacy store?",
  "How many pharmacists are working in your pharmacy?",
  "Do you have a delivery person / staff to deliver orders to your customers?",
  "Delivery Person Name",
  "Delivery Person Number",
  "Do you have Poc for your retail pharmacy store",
  "Poc Name",
  "Poc Number",
  "Are you currently part of any online pharmacy / health-tech platforms?",
  "Do you have a wholesale license?",
  "Do you currently use any billing / sales / ERP software?",
  "Pharmacy Available",
  "Pharmacy Start Time",
  "Pharmacy End Time",
  "BD Name",
  "App Download Android Click",
  "Brochure Icon Click Status (1.0)",
  "Assigned To",
  "Lead Status",
  // "Actions"
];

export const InstaDocRegistrationcolumnOrder = [
  "S.No",
  "Time of Registration",
  "Date of Registration",
  "Name of the Doctor",
  "Contact Number",
  "Email ID",
  "Degree",
  "Other Education",
  "Gender",
  "Primary Specialisation",
  "MCI / SMC Number",
  "Year of Registration with Medical Council",
  "Are you okay to receive online consultations from 9 PM - 9 AM ( Night - Day )",
  "State",
  "City",
  "Location",
  "Pincode",
  "Language",
  "BD Name",
  "App Download Android Click",
  "Brochure Icon Click Status (1.0)",
  "Assigned To",
  "Lead Status",
];
export const OtherscolumnOrder = [
  "S.No",
  "Name",
  "Mobile Number",
  "Email ID",
  "Type",
  "City / Town Location",
  "Message",
  "Registration Date and Time",
  "Assigned To",
  "Lead Status",
];

export const BookDemocolumnOrder = [
  "S.No",
  "Name",
  "Email",
  "Mobile Number",
  "Specialisation",
  "Preferred Contact Time",
  "Registration Date and Time",
  "Assigned To",
  "Lead Status",
];

const DoctorRegistrationTable = ({
  records,
  skip,
  setAssignModal,
  setLeadStatusModal,
  setDeleteId,
  setShowDelete,
  fetchData,
  loader = false,
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      fixed: "left",
      render: (text, record, index) => skip + (index + 1),
    },
    {
      title: "Name of the Doctor",
      dataIndex: "name",
      fixed: "left",
      width: 220,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },

    // {
    //   title: "Date of Registration",
    //   dataIndex: "createdAt",
    //   render: (text) => Moment(text).format("DD-MM-YYYY"),
    //   width: 220,
    // },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },

    { title: "Contact Number", dataIndex: "mobile", width: 200 },
    {
      title: "Email ID",
      dataIndex: "email",
      width: 120,
    },
    {
      title: "Degree",
      dataIndex: "degree",
      render: (text, record) => `${record.degree}, ${record.education}`,
    },
    {
      title: "PG Degree",
      dataIndex: "pg_degree",
      render: (text, record) =>
        record.pg_degree ? `${record.pg_degree}, ${record.pg_education}` : "-",
      width: 180,
    },
    // {
    //   title: "Other Certified Education",
    //   dataIndex: "qualification",
    //   width: 200,
    // },
    {
      title: "Other Certified Course",
      dataIndex: "qualification",
      width: 200,
    },
    { title: "Gender", dataIndex: "gender" },
    { title: "Primary Specialisation", dataIndex: "specialization" },
    { title: "MCI / SMC Number", dataIndex: "mci" },
    {
      title: "Year of Registration with Medical Council",
      dataIndex: "registered_year",
      width: 200,
    },
    { title: "Council Type", dataIndex: "council_type" },
    { title: "State Medical Council", dataIndex: "medical_council" },
    {
      title: "Awards & Recognition",
      dataIndex: "awards_recognition",
      width: 200,
    },
    {
      title: "Organisation",
      dataIndex: "organisation",
      render: (text, record) => record.organisation?.join(", ") || "-",
    },
    { title: "Fellowship", dataIndex: "fellowship" },
    { title: "Mode of Consultation", dataIndex: "intrested_mode" },
    { title: "Memberships", dataIndex: "memberships", width: 300 },
    { title: "About Yourself", dataIndex: "about", width: 600 },
    { title: "Online Fee", dataIndex: "online_consultation_fee" },
    { title: "In-Clinic Fee", dataIndex: "in_clinic_fee" },
    { title: "Primary Language", dataIndex: "primary_language" },
    {
      title: "Other Language Known",
      dataIndex: "languages_known",
      render: (text) => text?.join(", ") || "-",
    },
    { title: "State", dataIndex: "state" },
    { title: "City", dataIndex: "city" },
    { title: "Location", dataIndex: "location" },
    { title: "Pincode", dataIndex: "pincode" },
    { title: "Clinic Name", dataIndex: "clinic_name" },
    { title: "Clinic Address", dataIndex: "clinic_address", width: 400 },
    { title: "Clinic Contact Number", dataIndex: "clinic_contact_number" },
    { title: "PoC Name", dataIndex: "poc_clinic_name" },
    { title: "PoC Contact Number", dataIndex: "poc_clinic_contact_no" },
    {
      title: "Clinic Name - 2",
      key: "clinic_name_2",
      render: (_, record) => record.clinic_details?.[1]?.clinic_name || "N/A",
    },
    {
      title: "Clinic Address - 2",
      key: "clinic_address- 2",
      render: (_, record) =>
        // record.clinic_details?.[0]?.clinic_address || "N/A",
        record.clinic_details?.[1]?.clinic_address || "N/A",
    },
    {
      title: "Clinic Contact Number- 2",
      key: "clinic_contact_number",
      render: (_, record) =>
        record.clinic_details?.[1]?.clinic_contact_number || "N/A",
    },
    {
      title: "PoC Name - 2",
      key: "PoC Name - 2",
      render: (_, record) =>
        record.clinic_details?.[1]?.poc_clinic_name || "N/A",
    },
    {
      title: "PoC Contact Number - 2",
      key: "PoC Contact Number - 2",
      render: (_, record) =>
        record.clinic_details?.[1]?.poc_clinic_contact_no || "N/A",
    },
    {
      title: "Clinic Name - 3",
      render: (_, record) => record.clinic_details?.[2]?.clinic_name || "N/A",
    },
    {
      title: "Clinic Address - 3",
      render: (_, record) =>
        record.clinic_details?.[2]?.clinic_address || "N/A",

      width: 400,
    },
    {
      title: "Clinic Contact Number- 3",
      key: "clinic_contact_number",
      render: (_, record) =>
        record.clinic_details?.[2]?.clinic_contact_number || "N/A",
    },
    {
      title: "PoC Name - 3",
      render: (_, record) =>
        record.clinic_details?.[2]?.poc_clinic_name || "N/A",
    },
    {
      title: "PoC Contact Number - 3",
      key: "PoC Contact Number - 3",
      render: (_, record) =>
        record.clinic_details?.[2]?.poc_clinic_contact_no || "N/A",
    },
    { title: "Telemedicine Platform", dataIndex: "telemedicine" },
    { title: "Establishment Details", dataIndex: "establishment" },
    { title: "Assigned To", dataIndex: "assigned_to" },
    { title: "Lead Status", dataIndex: "lead_status" },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Actions
          isAssignedTo={true}
          isDelete={true}
          isEdit={true}
          isLeadStatus={true}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickEdit={() =>
            navigate(`/doctor-registration-edit/${record._id}`)
          }
          onClickLeadStatus={() =>
            setLeadStatusModal({ id: record._id, status: true })
          }
          onClickAssignedTo={() =>
            setAssignModal({ id: record._id, status: true })
          }
        />
      ),
    },
  ];

  const dataSource = records.filter(
    (x) => x.show === undefined || x.show === true
  );

  return (
    <>
      {!loader ? (
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}
    </>
  );
};

const PharmacyRegistrationTable = ({
  filtered_records,
  records,
  skip,
  setAssignModal,
  setLeadStatusModal,
  setDeleteId,
  setShowDelete,
  loader = false,
}) => {
  const navigate = useNavigate();

  const renderNA = (text) => (text ? text : "N/A");

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => skip + (index + 1),
      fixed: "left",
    },
    { title: "First Name", dataIndex: "first_name", fixed: "left", width: 200 },
    {
      title: "Last Name",
      dataIndex: "last_name",
      render: renderNA,
      fixed: "left",
      width: 200,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },
    // {
    //   title: "Date of Registration",
    //   dataIndex: "createdAt",
    //   width: 260,
    //   render: (text) => Moment(text).format("DD-MM-YYYY"),
    // },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },
    {
      title: "Pharmacy Name",
      width: 260,
      render: (_, record) =>
        record.pharmacy_owner_name || record.pharmacy_name || "N/A",
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile",
      width: 260,
      render: renderNA,
    },
    { title: "Email ID", dataIndex: "email", width: 260, render: renderNA },
    {
      title: "Pharmacy Business Type",
      dataIndex: "business_type",
      render: renderNA,
      width: 260,
    },
    {
      title: "Company Name (If Pharmacy name & Company name is different)",
      dataIndex: "company_name",
      render: renderNA,
      width: 320,
    },
    {
      title: "Pharmacy GST Number",
      dataIndex: "gst_no",
      render: renderNA,
      width: 260,
    },
    {
      title: "Drug License Number",
      dataIndex: "pharmacy_registration_number",
      render: renderNA,
      width: 260,
    },
    {
      title: "FSSAI Number",
      dataIndex: "fssai_license_no",
      width: 260,
      render: renderNA,
    },
    {
      title: "Pharmacist Name",
      dataIndex: "pharmacist_name",
      render: renderNA,
      width: 260,
    },
    {
      title: "Your pharmacist's license number",
      dataIndex: "pharmacist_license_number",
      render: renderNA,
      width: 330,
    },
    { title: "State", dataIndex: "state", render: renderNA },
    { title: "City", dataIndex: "pharmacy_town", render: renderNA },
    {
      title: "Pharmacy Location",
      dataIndex: "pharmacy_location",
      render: renderNA,
      width: 200,
    },
    {
      title: "Address",
      dataIndex: "pharmacy_address",
      render: renderNA,
      width: 250,
    },
    { title: "Pincode", dataIndex: "pincode", render: renderNA },
    {
      title: "Medicines Listing Fee (%)",
      dataIndex: "discounts_on_products",
      render: renderNA,
      width: 250,
    },
    {
      title: "OTC Listing Fee (%)",
      dataIndex: "discount_on_OTC",
      render: renderNA,
      width: 250,
    },
    {
      title: "What is the approximate size of your pharmacy store?",
      dataIndex: "size",
      render: renderNA,
      width: 350,
    },
    {
      title: "What is the value of inventory you have in your pharmacy store?",
      dataIndex: "value_of_inventory",
      width: 250,
      render: renderNA,
    },
    {
      title: "How many pharmacists are working in your pharmacy?",
      dataIndex: "pharmacists_count",
      render: renderNA,
      width: 300,
    },
    {
      title:
        "Do you have a delivery person / staff to deliver orders to your customers?",
      dataIndex: "have_delivery_person",
      render: renderNA,
      width: 250,
    },
    {
      title: "Delivery Person Name",
      dataIndex: "delivery_person_name",
      render: renderNA,
      width: 200,
    },
    {
      title: "Delivery Person Number",
      dataIndex: "delivery_person_number",
      render: renderNA,
      width: 250,
    },
    {
      title: "Do you have Poc for your retail pharmact store",
      dataIndex: "poc_retail_pharmacy_store",
      render: renderNA,
      width: 200,
    },
    { title: "PoC Name", dataIndex: "poc_name", render: renderNA, width: 200 },
    {
      title: "PoC Number",
      dataIndex: "poc_number",
      render: renderNA,
      width: 180,
    },
    {
      title:
        "Are you currently part of any online pharmacy / health-tech platforms?",
      dataIndex: "online_pharmacy",
      render: renderNA,
      width: 400,
    },
    {
      title: "Do you have a wholesale license?",
      dataIndex: "have_wholesale_license",
      render: renderNA,
      width: 250,
    },
    {
      title: "Do you currently use any billing / sales / ERP software?",
      dataIndex: "billing_software",
      render: renderNA,
      width: 300,
    },
    {
      title: "Pharmacy Available",
      dataIndex: "pharmacy_available",
      render: renderNA,
      width: 180,
    },
    {
      title: "Pharmacy Start Time",
      dataIndex: "pharmacy_start_timing",
      render: (text) => (text ? Moment(text).format("h:mm A") : "N/A"),
      width: 180,
    },
    {
      title: "Pharmacy End Time",
      dataIndex: "pharmacy_end_timing",
      render: (text) => (text ? Moment(text).format("h:mm A") : "N/A"),
      width: 180,
    },
    { title: "BD Name", render: () => "N/A", width: 200 },
    {
      title: "App Download Android Click",
      dataIndex: "android_click",
      render: renderNA,
      width: 200,
    },
    {
      title: "Brochure Icon Click Status (1.0)",
      dataIndex: "brochure_click",
      render: renderNA,
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: renderNA,
      width: 200,
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      render: renderNA,
      width: 200,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isAssignedTo={true}
          isDelete={true}
          isEdit={true}
          isLeadStatus={true}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickEdit={() =>
            navigate(`/pharmacy-registration-edit/${record._id}`)
          }
          onClickLeadStatus={() =>
            setLeadStatusModal({ id: record._id, status: true })
          }
          onClickAssignedTo={() =>
            setAssignModal({ id: record._id, status: true })
          }
        />
      ),
    },
  ];

  const dataSource = (
    filtered_records?.length > 0 ? filtered_records : records
  ).filter((x) => x.show === undefined || x.show === true);

  return (
    <>
      {!loader ? (
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}
    </>
  );
};

const HealthcareRegistrationTable = ({
  filtered_records,
  records,
  skip,
  setAssignModal,
  setLeadStatusModal,
  setId,
  setDel,
  fetchData,
  loader = false,
}) => {
  const navigate = useNavigate();

  const renderNA = (text) => (text ? text : "N/A");

  const columns = [
    {
      title: "S No",
      render: (_, __, index) => skip + (index + 1),
      fixed: "left",
    },
    { title: "Name of the HHSP", dataIndex: "name", fixed: "left", width: 220 },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },
    // {
    //   title: "Date of Registration",
    //   dataIndex: "createdAt",
    //   render: (text) => Moment(text).format("DD-MM-YYYY"),
    // },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },
    { title: "Mobile Number", dataIndex: "mobile" },
    { title: "Email ID", dataIndex: "email" },
    {
      title: "Degree",
      width: 180,
      render: (_, record) => record.degree || record.qualification || "N/A",
    },
    {
      title: "Other Certified Courses",
      dataIndex: "other_certified_courses",
      render: renderNA,
      width: 200,
    },
    { title: "Age", dataIndex: "age", render: renderNA },
    { title: "Gender", dataIndex: "gender", render: renderNA },
    {
      title: "Service Category",
      dataIndex: "service_category",
      render: renderNA,
    },
    {
      title: "Experience (Year of Start)",
      dataIndex: "experience",
      width: 180,
      render: renderNA,
    },
    {
      title: "License Number / Council Number / Registration Number",
      dataIndex: "license_number",
      width: 180,
      render: renderNA,
    },
    {
      title: "Memberships / Associations Details",
      dataIndex: "memberships_or_associations",
      render: renderNA,
      width: 200,
    },
    {
      title: "About Yourself",
      dataIndex: "about",
      render: renderNA,
      width: 400,
    },
    { title: "Fee", dataIndex: "fee", render: renderNA },
    {
      title: "Are your currently available on other home healthcare platforms?",
      dataIndex: "other_home_healthcare_platforms",
      render: renderNA,
      width: 220,
    },
    {
      title: "Your Current Organisation Name (Hospital / Clinic Name)",
      dataIndex: "establishment",
      render: renderNA,
      width: 220,
    },
    {
      title: "Language",
      render: (_, record) =>
        record.languages_known?.length
          ? record.languages_known.join(", ")
          : "N/A",
    },
    { title: "State", dataIndex: "state", render: renderNA, width: 200 },
    { title: "City", dataIndex: "city", render: renderNA, width: 200 },
    {
      title: "Location (City / Town)",
      dataIndex: "location",
      render: renderNA,
      width: 200,
    },
    { title: "Address", dataIndex: "address", render: renderNA, width: 400 },
    { title: "Pincode", dataIndex: "pincode", render: renderNA, width: 200 },
    { title: "BD Name", render: () => "N/A", width: 200 },
    {
      title: "App Download Android Click",
      dataIndex: "android_click",
      render: renderNA,
      width: 200,
    },
    {
      title: "App Download iOS Click",
      dataIndex: "ios_click",
      render: renderNA,
      width: 200,
    },
    {
      title: "Brochure Icon Click Status (1.0)",
      dataIndex: "brochure_click",
      render: renderNA,
      width: 200,
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: renderNA,
      width: 200,
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      render: renderNA,
      width: 280,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isAssignedTo={true}
          isLeadStatus={true}
          isDelete={true}
          isEdit={true}
          onClickDelete={() => {
            setId(record._id);
            setDel(true);
            fetchData();
          }}
          onClickEdit={() =>
            navigate(`/healthcare-registration-edit/${record._id}`)
          }
          onClickLeadStatus={() =>
            setLeadStatusModal({ id: record._id, status: true })
          }
          onClickAssignedTo={() =>
            setAssignModal({ id: record._id, status: true })
          }
        />
      ),
    },
  ];

  const dataSource = (
    filtered_records?.length > 0 ? filtered_records : records
  ).filter((x) => x.show === undefined || x.show === true);

  return (
    <>
      {!loader ? (
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}
    </>
  );
};

const InstaDocRegistrationTable = ({
  filtered_records,
  records,
  skip,
  setAssignModal,
  setLeadStatusModal,
  setId,
  setDel,
  fetchData,
  loader = false,
}) => {
  const navigate = useNavigate();

  const renderNA = (text) => (text ? text : "N/A");

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => skip + (index + 1),
      fixed: "left",
    },
    {
      title: "Name of the Doctor",
      dataIndex: "name",
      render: renderNA,
      fixed: "left",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },
    // {
    //   title: "Date of Registration",
    //   dataIndex: "createdAt",
    //   render: (text) => Moment(text).format("DD-MM-YYYY"),
    // },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },
    { title: "Contact Number", dataIndex: "mobile", render: renderNA },
    {
      title: "Email ID",
      dataIndex: "email",
      render: renderNA,
      width: 150,
    },
    { title: "Degree", dataIndex: "degree", render: renderNA, width: 200 },
    {
      title: "Other Education",
      dataIndex: "other_course",
      render: renderNA,
      width: 200,
    },
    { title: "Gender", dataIndex: "gender", render: renderNA, width: 200 },
    {
      title: "Primary Specialisation",
      dataIndex: "specialization",
      render: renderNA,
    },
    {
      title: "MCI / SMC Number",
      dataIndex: "mci",
      render: renderNA,
    },
    {
      title: "Year of Registration with Medical Council",
      dataIndex: "registered_year",
      render: renderNA,
      width: 200,
    },
    {
      title:
        "Are you okay to receive online consultations from 9 PM - 9 AM ( Night - Day )",
      dataIndex: "receive_online_consultations",
      render: renderNA,
      width: 270,
    },
    { title: "State", dataIndex: "state", render: renderNA, width: 200 },
    { title: "City", dataIndex: "city", render: renderNA },
    { title: "Location", dataIndex: "location", render: renderNA, width: 200 },
    { title: "Pincode", dataIndex: "pincode", render: renderNA, width: 200 },
    {
      title: "Language",
      width: 300,
      render: (_, record) =>
        record.languages_known?.length
          ? record.languages_known.join(", ")
          : "N/A",
    },
    {
      title: "BD Name",
      width: 200,
      render: () => "N/A",
    },
    {
      title: "App Download Android Click",
      dataIndex: "android_click",
      render: renderNA,
    },
    {
      title: "Brochure Icon Click Status (1.0)",
      dataIndex: "brochure_click",
      render: renderNA,
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: renderNA,
      width: 200,
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      render: renderNA,
      width: 280,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isAssignedTo={true}
          isLeadStatus={true}
          isEdit={true}
          isDelete={true}
          onClickDelete={() => {
            setId(record._id);
            setDel(true);
            fetchData();
          }}
          onClickEdit={() =>
            navigate(`/insta-doc-registration-edit/${record._id}`)
          }
          onClickLeadStatus={() =>
            setLeadStatusModal({ id: record._id, status: true })
          }
          onClickAssignedTo={() =>
            setAssignModal({ id: record._id, status: true })
          }
        />
      ),
    },
  ];

  const dataSource = (
    filtered_records?.length > 0 ? filtered_records : records
  ).filter((x) => x.show === undefined || x.show === true);

  return (
    <>
      {!loader ? (
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}
    </>
  );
};

const OtherRegistrationTable = ({
  filtered_records,
  records,
  handleContact,
  handleOnBoard,
  handleNotContact,
  setId,
  setDel,
  setAssignModal,
  setLeadStatusModal,
  skip,
  loader = false,
}) => {
  const getCurrentAction = (record) => {
    if (record.contact) return "Contact";
    if (record.onBoard) return "On-Board";
    if (record.notContacted) return "Not Contacted";
    return "Select";
  };

  const actionOptions = [
    { label: "Select", value: "Select" },
    { label: "Contact", value: "Contact" },
    { label: "On-Board", value: "On-Board" },
    { label: "Not Contacted", value: "Not Contacted" },
  ];

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => skip + (index + 1),
      fixed: "left",
    },
    { title: "Name", dataIndex: "name", fixed: "left", width: 200 },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },
    { title: "Mobile Number", dataIndex: "mobile", width: 180 },
    { title: "Email ID", dataIndex: "email", width: 200 },
    { title: "Type", dataIndex: "type", width: 180 },
    { title: "City / Town Location", dataIndex: "location", width: 250 },
    {
      title: "Message",
      dataIndex: "message",
      render: (text) => text || "-",
      width: 600,
    },
    // {
    //   title: "Registration Date and Time",
    //   dataIndex: "createdAt",
    //   render: (text) => Moment(text).format("DD MMMM YYYY LT"),
    //   width: 280,
    // },

    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: (text) => text || "-",
      width: 180,
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      render: (text) => text || "-",
      width: 180,
    },

    {
      title: "Actions",
      key: "actions",
      width: 650,
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <SelectComponent
            props={{
              Array: actionOptions,
              value: getCurrentAction(record),
              style: { color: "#CB1B5B", width: "200px" },
              onChange: async (e) => {
                const value = await e;
                const id = await record._id;
                if (value === "Contact") handleContact(id);
                else if (value === "On-Board") handleOnBoard(id);
                else if (value === "Not Contacted") handleNotContact(id);
              },
            }}
          />
          <Actions
            isAssignedTo={true}
            isLeadStatus={true}
            isDelete={true}
            onClickDelete={() => {
              setId(record._id);
              setDel(true);
            }}
            onClickLeadStatus={() =>
              setLeadStatusModal({ id: record._id, status: true })
            }
            onClickAssignedTo={() =>
              setAssignModal({ id: record._id, status: true })
            }
          />
        </div>
      ),
    },
  ];

  const dataSource = (
    filtered_records.length > 0 ? filtered_records : records
  ).filter((x) => x.show === undefined || x.show === true);

  return (
    <>
      {!loader ? (
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}
    </>
  );
};

const DoctorDemoTable = ({
  filtered_records,
  records,
  skip,
  handleContact,
  handleOnBoard,
  handleNotContact,
  setId,
  setDel,
  setAssignModal,
  setLeadStatusModal,
  loader = false,
}) => {
  const getCurrentAction = (record) => {
    if (record.contact) return "Contact";
    if (record.onBoard) return "On-Board";
    if (record.notContacted) return "Not Contacted";
    return "Select";
  };

  const actionOptions = [
    { label: "Select", value: "Select" },
    { label: "Contact", value: "Contact" },
    { label: "On-Board", value: "On-Board" },
    { label: "Not Contacted", value: "Not Contacted" },
  ];

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => skip + (index + 1),
      fixed: "left",
    },
    { title: "Name", dataIndex: "name", fixed: "left", width: 200 },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },
    { title: "Email", dataIndex: "email" },
    { title: "Mobile Number", dataIndex: "mobile", width: 200 },
    { title: "Specialisation", dataIndex: "specialization" },
    {
      title: "Preferred Contact Time",
      dataIndex: "time",
      render: (text) => text || "-",
      width: 280,
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: (text) => text || "-",
      width: 200,
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      render: (text) => text || "-",
      width: 200,
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <SelectComponent
            props={{
              Array: actionOptions,
              value: getCurrentAction(record),
              style: { color: "#CB1B5B", width: "200px" },
              onChange: async (e) => {
                const value = await e;
                const id = await record._id;
                if (value === "Contact") handleContact(id);
                else if (value === "On-Board") handleOnBoard(id);
                else if (value === "Not Contacted") handleNotContact(id);
              },
            }}
          />
          <Actions
            isAssignedTo={true}
            isLeadStatus={true}
            isDelete={true}
            onClickDelete={() => {
              setId(record._id);
              setDel(true);
            }}
            onClickLeadStatus={() =>
              setLeadStatusModal({ id: record._id, status: true })
            }
            onClickAssignedTo={() =>
              setAssignModal({ id: record._id, status: true })
            }
          />
        </div>
      ),
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   width: 200,
    //   render: (_, x) => (
    //     <>
    //       <Button
    //         type="link"
    //         className={x.contact ? "contact-highlight" : ""}
    //         onClick={() => handleContact(x._id)}
    //       >
    //         Contact
    //       </Button>
    //       <img src={contact} alt="contact" className="mx-1" />

    //       <Button
    //         type="link"
    //         className={x.onBoard ? "onboard-highlight" : ""}
    //         onClick={() => handleOnBoard(x._id)}
    //       >
    //         On-Board
    //       </Button>
    //       <img src={onboard} alt="onboard" className="mx-1" />

    //       <Button
    //         type="link"
    //         className={x.notContacted ? "notcontact-highlight" : ""}
    //         onClick={() => handleNotContact(x._id)}
    //       >
    //         Not Contacted
    //       </Button>
    //       <img src={notcontact} alt="notcontact" className="mx-1" />

    //       <Popconfirm
    //         title="Are you sure you want to delete this entry?"
    //         onConfirm={() => {
    //           setId(x._id);
    //           setDel(true);
    //         }}
    //       >
    //         <Button type="link" danger>
    //           Delete
    //         </Button>
    //       </Popconfirm>
    //       <img src={newdelete} alt="delete" className="mx-1" />

    //       <Button
    //         type="link"
    //         onClick={() => setAssignModal({ id: x._id, status: true })}
    //       >
    //         Assigned To <FaAngleDown className="drop-down-arrow" />
    //       </Button>

    //       <Button
    //         type="link"
    //         onClick={() => setLeadStatusModal({ id: x._id, status: true })}
    //       >
    //         Lead Status <FaAngleDown className="drop-down-arrow" />
    //       </Button>
    //     </>
    //   ),
    // },
  ];

  const dataSource = (
    filtered_records.length > 0 ? filtered_records : records
  ).filter((x) => x.show === undefined || x.show === true);

  return (
    <>
      {!loader ? (
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          rowKey="_id"
          pagination={false}
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}
    </>
  );
};

export {
  DoctorDemoTable,
  DoctorRegistrationTable,
  HealthcareRegistrationTable,
  InstaDocRegistrationTable,
  OtherRegistrationTable,
  PharmacyRegistrationTable,
};
